import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'app-buttons-preview-generate',
	templateUrl: './buttons-preview-generate.component.html',
	styleUrls: ['./buttons-preview-generate.component.scss']
})
export class ButtonsPreviewGenerateComponent {
	@Input() componentData;
	@Input() refresh;
	@Input() refreshType;
	@Input() disableSave;
	@Input() refreshText;
	@Output() generateComponent = new EventEmitter<any>();
	@Output() updatePreview = new EventEmitter<any>();

	saveComponent(event) {
		this.generateComponent.emit(event);
	}

	renderWidget(event) {
		this.updatePreview.emit(event);
	}
}
